export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const LOADING = 'LOADING';
export const SAVE_SEARCH_PARAM = 'SAVE_SEARCH_PARAM';
export const SAVE_PAGINATION_DATA = 'SAVE_PAGINATION_DATA';